import { useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const STORAGE_KEY = "app:last_seen_backend_version";
const ACK_KEY = "app:acknowledged_backend_version";

export default function useAppVersion() {
  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      try {
        const res = await axios.get(`${API}/version`, {
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
          },
        });
        if (cancelled) return;

        const versionId = res?.data?.version_id;
        if (!versionId) return;

        const lastSeen = localStorage.getItem(STORAGE_KEY);
        const acknowledged = localStorage.getItem(ACK_KEY);

        // Only prompt if server version differs from what we last saw AND the user hasn't already acknowledged it.
        if (lastSeen && lastSeen !== versionId && acknowledged !== versionId) {
          window.dispatchEvent(
            new CustomEvent("app:update_available", { detail: { versionId } }),
          );
        }

        localStorage.setItem(STORAGE_KEY, versionId);
      } catch {
        // Ignore version check errors
      }
    };

    check();
    const i = setInterval(check, 60_000);

    return () => {
      cancelled = true;
      clearInterval(i);
    };
  }, []);
}
